import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'
import { Modal } from '@navent-jobs/ui-kit/components/modal'

export const ModalComponent = styled(Modal)``

export const FooterContent = styled.div`
  display: flex;
  justify-content: center;
`

export const ModalFooterComponent = styled.div``

export const CustomButton = styled(Button)`
  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    max-width: 200px;
  }

  &:first-child&:not(:only-child) {
    margin-right: 24px;
  }
`

export const Container = styled.div`
  padding-bottom: 20px;
`

export const TitleContainer = styled.div`
  display: flex;
`

export const IconContainer = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
`
